import type { Message } from "@/lib/types";

export function threadRootFromMessage(message: Pick<Message, "id" | "parentId" | "threadRootId">): string {
  return message.threadRootId || message.parentId || message.id;
}
